import { EACH_UOM as SHARED_EACH_UOM, computeAbsoluteEaches } from '../../../../../../constants/units-of-measure';
import type { UomInfo } from '../components/product-search-input/types';

export const EACH_UOM: UomInfo = SHARED_EACH_UOM;

export const buildUnitsOfMeasure = (apiUoms: UomInfo[]): UomInfo[] => [EACH_UOM, ...apiUoms];

export const getConversionFactorByUomId = (unitsOfMeasure: UomInfo[] | undefined, unitOfMeasureId: number | undefined): number => {
  if (!unitOfMeasureId || !unitsOfMeasure) return 1;
  return unitsOfMeasure.find((u) => u.productUnitOfMeasureId === unitOfMeasureId)?.conversionFactor ?? 1;
};

export const getAbsoluteEachesByUomId = (unitsOfMeasure: UomInfo[] | undefined, unitOfMeasureId: number | null | undefined): number => {
  if (unitOfMeasureId == null || unitOfMeasureId === 0 || !unitsOfMeasure) return 1;
  return computeAbsoluteEaches(unitOfMeasureId, unitsOfMeasure);
};

export const toBaseQuantity = (quantityInUom: number, absoluteEaches: number): number => Math.ceil(quantityInUom * absoluteEaches);

export const toUomQuantity = (baseQuantity: number, absoluteEaches: number): number => Math.floor(baseQuantity / absoluteEaches);
